<template>
  <div class="page">
    <fieldset>
      <legend>Review Items (<span style="color: #6abaec">{{ itemsReadyForReview.length }}</span> ready)</legend>

      <div class="pool-list-container">
        <table class="pool-list">
          <tr>
            <th>English</th>
            <th>Thai</th>
            <th>Note</th>
            <th>Next Review</th>
            <th>Delete</th>
          </tr>
          <tr
            class="pool-list__row"
            v-for="item in reviewItems"
            v-bind:key="item.id"
          >
            <td>
              <EditableItemProperty
                v-bind:item="item"
                v-bind:propertyPath="['properties', 'english', 'value']"
                />
            </td>

            <td>
              <EditableItemProperty
                v-bind:item="item"
                v-bind:propertyPath="['properties', 'thai', 'value']"
                />
            </td>

            <td>
              <EditableItemProperty
                v-bind:item="item"
                v-bind:propertyPath="['properties', 'note', 'value']"
                />
            </td>

            <td>
              {{ item.daysToNextReview() }}

              <!-- <Promised :promise="getComplexity(item)">
                <div slot="pending"></div>
                <div slot="rejected" slot-scope="error">{{ error.message }}</div>
                <div slot-scope="complexity">
                  {{ complexity }}
                </div>
              </Promised> -->
            </td>

            <td>
              <button class="btn--small" v-on:click="deleteItem(item)">╳</button>
            </td>
          </tr>
        </table>
      </div>
    </fieldset>

  </div>
</template>

<style lang="scss">
table {
  border-collapse: collapse;
}

.pool-list__row:nth-of-type(odd) td {
  background: rgb(240, 240, 240);
}

.pool-list__row--disabled td {
  background: pink !important;
}
</style>

<script>
import Vue from 'vue';
import { Promised } from 'vue-promised';
Vue.component('Promised', Promised);

import { mapGetters } from 'vuex';

import * as db from '@/libs/db.js';
import EditableItemProperty from '@/components/EditableItemProperty.vue';

export default {
  name: 'ReviewItemsManager',
  store: db.store,
  components: {
    Promised,
  },
  data: function() {
    return {
      newItemDetails: '',
      itemComplexity: {},
    }
  },
  components: {
    EditableItemProperty,
  },
  computed: {
    ...mapGetters(['reviewItems', 'itemsReadyForReview']),
  },
  methods: {
    // daysToNextReview(item) {
    //   return Math.round(daysToNextReview(item) * 100) / 100;
    // },
    async deleteItem(item) {
      await this.$store.dispatch('deleteItem', item.id);
    },
  },
  mounted() {
    // this.$store.dispatch('init');
  },
}
</script>

<style scoped lang="scss">
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
</style>
